import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';

class DropDownKetQuaTiepDan extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label="Kết quả tiếp dân" selectedValue={this.props.selectedValue} options={ this.props.data } className={this.props.className} keyName='giaTri' 
        valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownKetQuaTiepDan.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: '--Chọn--'
  },
  selectedValue: ''
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.ketQuaTiepDan
  }
}

export default connect(bindStateToProps)(DropDownKetQuaTiepDan);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-ketquatiepdan.jsx